/**
 * 2026-10-21 (owner) · a photo / file attachment for a step (services/recipe/attach_setting.py).
 *
 * "Sab step type ke liye rahega, line clearance chhod ke — right side panel me as an option enable kiya
 * to operator view me us step ke liye wo attachment lene ke liye aayega, aur required hoga." On: the
 * operator must take a photo on the tablet or upload a file before the step can be submitted, and the
 * server refuses it otherwise. Not drawn on a clearance (its profile asks for the clearance format) or a
 * cleaning (it has its own photo of the cleaning record).
 */
import React from "react";
import { Button, Input, Switch, Tag } from "antd";
import { CameraOutlined, PaperClipOutlined, UploadOutlined } from "@ant-design/icons";
import { Field } from "./Field";

const NOT_ON = ["CLEARANCE", "CLEANING"];
const muted = { color: "var(--dz-faint, #64748b)", fontSize: 12.5 };

export function AttachmentField({ step, readOnly, onChange, vocab }) {
  if (NOT_ON.includes(String(step?.step_type || "").toUpperCase())) return null;
  const cfg = step?.attachment || {};
  const on = !!cfg.required;
  if (readOnly && !on) return null;     // 2026-10-29 (owner) · a read-only step shows only what was configured
  const what = cfg.what || "";
  const accepted = vocab?.cleaning?.accepted?.words || "JPG, PNG, PDF · up to 10 MB";
  const save = (patch) => onChange({ attachment: { required: on, what, ...patch } });
  return (
    <div className="u0-sepbefore">
    <Field label={<span><CameraOutlined /> Photo / file attachment</span>}
           hint="Switched on, the operator must take a photo on the tablet or upload a file before submitting this step.">
      <div style={{ width: "100%" }}>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <Switch checked={on} disabled={readOnly} onChange={(v) => save({ required: v })} data-testid="step-attach-switch" />
          <Tag color={on ? "red" : undefined}>{on ? "Required" : "Not asked"}</Tag>
        </span>
        <div className="u0-edit-hint" style={{ ...muted, marginTop: 4 }}>
          {on ? "The operator must take a photo or upload a file for this step" : "No photo or file is asked for this step"}
          {" "}· {accepted}
        </div>
        {on ? (
          <>
            <Input style={{ marginTop: 8 }} disabled={readOnly} value={what} maxLength={200}
                   placeholder="What to attach — e.g. Photo of the balance printout"
                   onChange={(e) => save({ what: e.target.value })} />
            {/* What the operator will see on the tablet. */}
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8, padding: "8px 10px",
                          border: "1px dashed var(--dz-line, #dbe3ea)", borderRadius: 8, background: "#fff", flexWrap: "wrap" }}>
              <PaperClipOutlined style={{ fontSize: 16, color: "var(--dz-accent, #204448)" }} />
              <span style={{ flex: 1, minWidth: 150 }}>
                <div style={{ fontWeight: 600 }}>{what.trim() || "Attach a photo or file"} <span style={muted}>· required</span></div>
                <div style={muted}>Accepted: {accepted}</div>
              </span>
              <Button size="small" disabled icon={<CameraOutlined />}>Photo</Button>
              <Button size="small" disabled icon={<UploadOutlined />}>Upload</Button>
            </div>
          </>
        ) : null}
      </div>
    </Field>
    </div>
  );
}
